export const MODAL_WRAPPER = 'modal-wrapper'
export const MODAL_CONTENT = 'modal-content'
export const MODAL_CLOSE_BUTTON = 'modal-close-button'
